import { render, staticRenderFns } from "./AskedQuestions.vue?vue&type=template&id=52a835e9&"
import script from "./AskedQuestions.vue?vue&type=script&lang=js&"
export * from "./AskedQuestions.vue?vue&type=script&lang=js&"
import style0 from "./AskedQuestions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports